import { NaturalDisasterAlertScreen, RequestForbearance } from '../../components/NaturalDisaster';
import { ContactInformation, ReviewInformation } from '../../components/AuthenticatedLeadForms';
import { LocationInformation } from '../../components/PurchaseAndRefinance';
import { WithdrawalAmount } from '../../components/AuthenticatedLeadForms';
import RadioCardGroup from '../../components/RadioCardGroup';
const ComponentMap = {
  RadioCardGroup: RadioCardGroup,
  WithdrawalAmount: WithdrawalAmount,
  ReviewInformation: ReviewInformation,
  ContactInformation: ContactInformation,
  LocationInformation: LocationInformation,
  NaturalDisasterAlertScreen: NaturalDisasterAlertScreen,
  RequestForbearance: RequestForbearance
};
export default ComponentMap;
//# sourceMappingURL=index.js.map